import { useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import Modal from '../../../../common/Modals/Modal/Modal';
import './SellModal.scss';
import Button from '../../../../common/Button/Button';
import { CameraIcon, FullArrowIcon } from '../../../../../assets/icons/svgicons';
import Chart from '../../../../../assets/images/Chart.png';
import SellConfirm from '../../../../common/Modals/SellWithUs/SellConfirm/SellConfirm';
import Redeem from '../../Dashboard/WalletValueCard/Redeem/Redeem';
import { useDispatch } from 'react-redux';
import { saveTokeBalance } from '../../../../../features/user/userSlice';

const SellModal = ({
    show,
    handleClose,
    handleSellConfirm,
    tokenPrices,
    handleAssetTypeChange,
    selectedTokenPrice,
    selectedAsset,
    handleQuantityChange,
    quantity,
    formik,
    calculateTotal,
    buyPrices,
    setBuyPrices,
    updatedAssetOptions,
    coinList,
}) => {
    const [activeTab, setActiveTab] = useState("sellUs");
    const dispatch = useDispatch();

    return (
        <>
            <Modal
                show={show}
                handleClose={handleClose}
                className="sellModal"
            >
                <div className='sellModal_innerSec'>
                    <Tab.Container
                        id="left-tabs-example"
                        activeKey={activeTab}
                        onSelect={(k) => {
                            setActiveTab(k);
                            // dispatch(saveTokeBalance(0));
                        }}
                        className='tabContainer'
                    >
                        <div className='tabHeader'>
                            <Nav variant="pills" className='navTabs'>
                                <Nav.Item>
                                    <Nav.Link eventKey="sellUs">Sell to Us</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="redeem">Redeem</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </div>
                        <Tab.Content className='content_inner'>
                            <Tab.Pane eventKey="sellUs">
                                <SellConfirm
                                    show={show}
                                    handleSellConfirm={handleSellConfirm}
                                    tokenPrices={tokenPrices}
                                    handleAssetTypeChange={handleAssetTypeChange}
                                    selectedTokenPrice={selectedTokenPrice}
                                    selectedAsset={selectedAsset}
                                    activeTab={activeTab}
                                    handleQuantityChange={handleQuantityChange}
                                    quantity={quantity}
                                    formik={formik}
                                    calculateTotal={calculateTotal}
                                    buyPrices={buyPrices}
                                    setBuyPrices={setBuyPrices}
                                    updatedAssetOptions={updatedAssetOptions}
                                    coinList={coinList}
                                />
                            </Tab.Pane>
                            <Tab.Pane eventKey="redeem">
                                <Redeem selectedAsset={selectedAsset} activeTab={activeTab} />
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Modal>
        </>
    )
}

export default SellModal